import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/public/Home';
import TreatmentDetail from './pages/public/TreatmentDetail';
import BlogDetail from './pages/public/BlogDetail';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Login from './pages/admin/Login';
import AppointmentsAdmin from './pages/admin/AppointmentsAdmin';
import TreatmentsAdmin from './pages/admin/TreatmentsAdmin';
import TeamAdmin from './pages/admin/TeamAdmin';
import SliderAdmin from './pages/admin/SliderAdmin';
import SettingsAdmin from './pages/admin/SettingsAdmin';
import BeforeAfterAdmin from './pages/admin/BeforeAfterAdmin';
import BlogsAdmin from './pages/admin/BlogsAdmin';
import CorporateAdmin from './pages/admin/CorporateAdmin';
import TestimonialsAdmin from './pages/admin/TestimonialsAdmin';
import GalleryAdmin from './pages/admin/GalleryAdmin';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from 'sonner';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Yükleniyor...</div>;
  if (!user) return <Navigate to="/admin/login" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tedaviler/:id" element={<TreatmentDetail />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="appointments" element={<AppointmentsAdmin />} />
            <Route path="treatments" element={<TreatmentsAdmin />} />
            <Route path="team" element={<TeamAdmin />} />
            <Route path="slider" element={<SliderAdmin />} />
            <Route path="before-after" element={<BeforeAfterAdmin />} />
            <Route path="blogs" element={<BlogsAdmin />} />
            <Route path="corporate" element={<CorporateAdmin />} />
            <Route path="testimonials" element={<TestimonialsAdmin />} />
            <Route path="gallery" element={<GalleryAdmin />} />
            <Route path="settings" element={<SettingsAdmin />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
